import React from 'react';
import LazyLoad from 'react-lazyload';

// import styled from '@benzinga/themetron';
import { Grid } from '@benzinga/core-ui';
import { Entity, ProfileSection as ProfileSectionInterface } from '@benzinga/content-manager';
import { EntityCard } from '@benzinga/entity-ui';
import { SectionTitle } from '@benzinga/core-ui';
import { ReviewEntries, SubmitReviewBox } from '@benzinga/reviews-ui';
import { ContentFeed } from '@benzinga/news';
import { YouTubeVideoCard } from '@benzinga/ui';
import { MoneyBlocks } from '@benzinga/money';
import { TradingViewWidget } from '@benzinga/charts-ui';

interface ProfileSectionProps {
  entity: Entity;
  section: ProfileSectionInterface;
}

export const ProfileSection: React.FC<ProfileSectionProps> = ({ entity, section }) => {
  // console.log(section);
  if (section.type === 'entities') {
    return (
      <Grid>
        {section.entities?.map((entity: Entity) => (
          <EntityCard entity={entity} key={entity.id} showMoreButton={true} />
        ))}
      </Grid>
    );
  } else if (section.type === 'news') {
    return <ContentFeed contentId="Profile News" limit={10} loadMore query={section.query} />;
  } else if (section.type === 'chart') {
    return (
      <React.Suspense>
        <TradingViewWidget
          widgetProps={{ height: 400, symbol: `${section.exchange}:${section.symbol}`, width: '100%' }}
        />
      </React.Suspense>
    );
  } else if (section.type === 'videos') {
    return (
      <LazyLoad>
        <Grid>
          {section.videos.map(item => (
            <YouTubeVideoCard key={item.id} video={item} />
          ))}
        </Grid>
      </LazyLoad>
    );
  } else if (section.type === 'reviews') {
    return (
      <div>
        <ReviewEntries entries={section?.entries ?? []} />
        <SectionTitle bordered id="one-minute-opinion">
          Submit Your One Minute Opinion
        </SectionTitle>
        {section.form && (
          <SubmitReviewBox form={section.form} post={entity} title={`How do you like ${entity?.name}?`} />
        )}
      </div>
    );
  } else if (section.type === 'content') {
    return <MoneyBlocks blocks={section.blocks} />;
  }
  return null;
};
